/* altera-growave-fix.js
 *
 * Growave's reviews slider widget renders inside an open Shadow DOM,
 * so external CSS can't reach the .gw-image / .gw-image__content
 * elements. This script:
 *
 *   1. Watches for Growave's widget host elements to mount
 *   2. Injects CSS directly into each widget's shadow root
 *      to fix the cropped sock images + apply Altera brand styling
 *   3. Also hides Growave's default header ("Our customers love us")
 *      so the custom Altera Reviews Header section can replace it
 *
 * Loads globally via layout/theme.liquid.
 */
(function () {
  if (typeof window === 'undefined' || !document.documentElement) return;

  var INJECTED_CSS = [
    /* Hide Growave's main widget heading ("Our customers love us") so the
       custom Altera Reviews Header section can replace it. */
    '.gw-rv-main-slider-widget__title {',
    '  display: none !important;',
    '}',
    /* Add a parchment background behind the image so it reads cleanly
       when contain-fitted (no harsh white frame around the sock). */
    '.gw-image {',
    '  background: #f5f1ea !important;',
    '}',
    /* The actual <img>: change cover -> contain so the full sock shows. */
    '.gw-image__content {',
    '  object-fit: contain !important;',
    '  object-position: center !important;',
    '  padding: 10px !important;',
    '  box-sizing: border-box !important;',
    '}'
  ].join('\n');

  var injected = new WeakSet();

  function injectInto(root) {
    if (!root || injected.has(root)) return;
    injected.add(root);
    try {
      var style = document.createElement('style');
      style.setAttribute('data-altera-gw-fix', '');
      style.textContent = INJECTED_CSS;
      root.appendChild(style);
    } catch (e) { /* shadow root closed or detached */ }
  }

  function scan() {
    /* Common Growave widget host class names (across reviews / slider variants) */
    var selectors = [
      '.gw-rv-reviews-slider-widget-placeholder',
      '[class*="gw-rv"][class*="placeholder"]',
      '[class*="growave"][class*="reviews"]',
      '[class*="growave"][class*="slider"]'
    ].join(',');

    document.querySelectorAll(selectors).forEach(function (el) {
      if (el.shadowRoot) injectInto(el.shadowRoot);
    });
  }

  function start() {
    scan();
    /* Poll briefly since Growave bootstraps async after page paint */
    var attempts = 0;
    var iv = setInterval(function () {
      scan();
      if (++attempts > 40) clearInterval(iv); /* stop after ~20s */
    }, 500);

    /* Catch shadow roots that attach later (carousel re-render, etc.) */
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(scan);
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
